/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiRecreateIndex,
    InternalApiRecreateIndexFromJSON,
    InternalApiRecreateIndexToJSON,
} from '../models';

export interface RecreateRequest {
    internalApiRecreateIndex: InternalApiRecreateIndex;
}

/**
 * 
 */
export class SearchIndexApi extends runtime.BaseAPI {

    /**
     */
    async recreateRaw(requestParameters: RecreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRecreateIndex === null || requestParameters.internalApiRecreateIndex === undefined) {
            throw new runtime.RequiredError('internalApiRecreateIndex','Required parameter requestParameters.internalApiRecreateIndex was null or undefined when calling recreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/search-index`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRecreateIndexToJSON(requestParameters.internalApiRecreateIndex),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async recreate(requestParameters: RecreateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.recreateRaw(requestParameters, initOverrides);
    }

}
